'use client';

import { useState } from 'react';
import { Check, CircleAlert, Copy, RefreshCw } from 'lucide-react';
import Markdown from 'react-markdown';
import { Button } from '@repo/ui/components/button';
import { Card, CardContent } from '@repo/ui/components/card';
export const ErrorCard = ({
  error,
  retry = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }
}: {
  error: {
    title?: string;
    message: string;
    details?: string;
  };
  retry?: () => void;
}) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    await navigator.clipboard.writeText(JSON.stringify(error, null, 2));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <Card className="mx-auto max-w-md">
      <CardContent className="flex flex-col items-center gap-4 pt-6 text-center">
        <div className="bg-destructive flex size-12 items-center justify-center rounded-full">
          <CircleAlert className="text-destructive-foreground size-6" />
        </div>

        <div className="space-y-1.5">
          <h2 className="text-foreground text-lg font-semibold">
            {error.title || 'Something went wrong'}
          </h2>
          <p className="text-muted-foreground text-sm">{error.message}</p>
        </div>

        {error.details && <div className="bg-muted text-muted-foreground prose prose-sm prose-code:bg-muted-foreground/10 prose-code:rounded prose-code:px-1 w-full rounded-lg p-3 text-left text-sm">
            <Markdown>{error.details}</Markdown>
          </div>}

        <div className="flex items-center gap-2 pt-2">
          <Button onClick={retry} size="sm">
            <RefreshCw className="size-3.5" />
            Retry
          </Button>
          <Button variant="ghost" size="sm" onClick={handleCopy} aria-label="Copy error details to clipboard">
            {copied ? <Check className="size-3.5 text-green-600" /> : <Copy className="size-3.5" />}
            {copied ? 'Copied!' : 'Copy Error'}
          </Button>
        </div>
      </CardContent>
    </Card>;
};